import React from 'react';
import './PrivacyPolicy.scss';

const PrivacyPolicy = ({ useConditionsLink = true }) => {
    // Fonction pour générer une section sous forme de "card"
    const buildSection = (title, content) => (
        <div className="policy-card">
            <h3>{title}</h3>
            <p>{content}</p>
        </div>
    );

    // Contenu principal
    const content = (
        <div className="privacy-policy-content">
            <h2 className="policy-title">Politique de confidentialité</h2>

            {buildSection(
                'Introduction',
                `Nous prenons la confidentialité de vos données au sérieux. Voici les informations détaillées concernant la collecte et l'utilisation de vos données personnelles. ABI'S COMPANY, propriétaire de l'application Thespot, est responsable du traitement des données personnelles.`
            )}

            {buildSection(
                '1. Les données que nous collectons',
                `- Adresse e-mail : Nous collectons votre adresse e-mail via la connexion Apple pour créer un compte et vous permettre d'accéder à des fonctionnalités personnalisées.
                 - Nom et prénom : Ces informations sont facultatives et peuvent être fournies par vous si vous souhaitez personnaliser davantage votre profil.
                 - Localisation : Nous collectons votre localisation uniquement lors de certaines fonctionnalités spécifiques, mais nous ne stockons pas ces informations sur nos serveurs.
                 - Historique de recherche de spots : Nous stockons votre historique de recherche pour personnaliser les résultats.
                 - Avis et photos : Nous enregistrons les avis et photos que vous partagez sur l'application.`
            )}

            {buildSection(
                '2. Utilisation des données collectées',
                `Les données collectées sont utilisées pour la création et la gestion de votre compte, la personnalisation de votre expérience, le support client et pour garantir la sécurité de l’application.`
            )}

            {buildSection(
                '3. Partage des données',
                `Nous ne partageons actuellement aucune donnée personnelle avec des tiers sans votre consentement.`
            )}

            {buildSection(
                '4. Sécurisation des données',
                `Toutes les données collectées sont stockées sur des serveurs sécurisés avec des mesures appropriées pour protéger vos informations personnelles.`
            )}

            {buildSection(
                '5. Cookies et technologies similaires',
                `Nous n’utilisons pas de cookies à des fins publicitaires, mais des cookies de session peuvent être utilisés pour maintenir votre session active.`
            )}

            {buildSection(
                '6. Droits des utilisateurs',
                `Vous avez le droit d’accéder à vos données personnelles et de demander leur suppression à tout moment.`
            )}

            {buildSection(
                '7. Durée de conservation des données',
                `Les données sont conservées jusqu’à ce que vous demandiez leur suppression.`
            )}

            {buildSection(
                '8. Modifications de la politique de confidentialité',
                `Nous vous informerons des modifications de cette politique lors de votre prochaine connexion.`
            )}

            {/* Section Contact */}
            <div className="policy-card">
                <h3>9. Contact</h3>
                <p>
                    Si vous avez des questions ou souhaitez exercer vos droits, vous pouvez nous contacter à l'adresse suivante :
                </p>
                <a href="mailto:contact.thespot.mail@gmail.com" className="email-link">
                    contact.thespot.mail@gmail.com
                </a>
            </div>
        </div>
    );

    // Si useConditionsLink est true, on enveloppe le contenu dans ConditionsLink
    if (useConditionsLink) {
        return (
            <div className="placeholder-conditions-link">
                <p>Cliquer ici pour afficher la politique de confidentialité (ex. modal/bottom sheet).</p>
            </div>
        );
    }

    return content;
};

export default PrivacyPolicy;
